import React from 'react'
import { twMerge } from 'tailwind-merge'

interface ToolbarButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  variant?: keyof typeof variants
  className?: string
}

const baseClasses =
  'h-9 px-4 text-M rounded-md transition focus:outline-none cursor-pointer'

const variants = {
  primary: 'bg-btnPrimary text-textOnColor hover:bg-btnPrimaryHover',
  secondary:
    'border border-btnSecondaryBorder bg-btnSecondary text-btnPrimary hover:bg-btnSecondaryHover',
  tertiary:
    'border border-btnTertiaryBorder bg-btnTertiary text-btnPrimary hover:bg-btnTertiaryHover',
}

/* TODO: it's not from our design system, we should ask designers to replace it with
 * the ui-lib button component (src/editor/shared/ui-lib/buttons/button.tsx) */
/** @deprecated */
export const ToolbarButton = ({
  children,
  variant = 'primary',
  onClick,
  className = '',
  ...props
}: ToolbarButtonProps) => {
  return (
    <button
      className={twMerge(baseClasses, variants[variant], className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
}
